<!-- The pun that lands after every answer.

     Sits above the tab bar rather than over the question, because in a speed
     mode the next question is already on screen and covering it would cost him
     reading time he does not have.

     pointer-events are off in CSS: this must never eat the tap meant for the
     next answer.

     IT CARRIES A MARK AS WELL AS A COLOUR. The puns are the whole personality
     of this app and not one of them says whether it is good news — "Not bad,
     Austin." and "Not that one." are the same shape — so for a while the only
     thing separating a win from a miss was green versus red, on a screen held
     by a boy in daylight, at the exact moment he is looking somewhere else.
     The tick or the cross is the second channel; the word underneath it is the
     third, for the live region. Green and red still do most of the work, they
     just no longer do all of it.

     GOOD AND BAD ALSO MOVE DIFFERENTLY (app.css): a win rises and overshoots,
     a miss drops in and gets shaken off. Told apart at a glance, with the
     colour taken away. -->
<template>
  <Transition name="verdict">
    <div
      v-if="text"
      :key="text"
      class="verdict"
      :class="good ? 'good' : 'bad'"
      role="status"
      aria-live="polite"
    >
      <div>
        <span class="mark" aria-hidden="true">{{ good ? '✓' : '✕' }}</span>
        <span class="sr-only">{{ good ? 'Correct.' : 'Wrong.' }}</span>
        {{ text }}
        <span v-if="why" class="why">{{ why }}</span>
      </div>
    </div>
  </Transition>
</template>

<script setup>
defineProps({
  text: { type: String, default: '' },
  why: { type: String, default: '' },
  good: { type: Boolean, default: true },
});
</script>
